import React, { Fragment, useState } from 'react'
import { css } from '@linaria/core'
import { Link } from '@fs/zion-router'
import { Divider, Expander, ExpanderContent, ExpanderHeader, Paragraph, Separator, colors } from '@fs/zion-ui'
import { useCanAddPersonalData } from '@fs/zion-permissions'
import AppBtns from './AppBtns'
import { useDynamicLinkContext } from '../../DynamicLinksProvider'
import { buildUrl } from '../../footerHelperFunctions'

const linkCss = css`
  display: block;
  width: fit-content;
  color: ${colors.transparent.gray70} !important; // css loaded in different order on app. !important to override this.
  font-size: var(--text-size-a) !important; // css loaded in different order on app. !important to override this.
  outline-color: ${colors.transparent.gray70};
  outline-offset: 2px;
  margin-top: 8px;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`

const newCss = css`
  color: ${colors.green40};
`

const listCss = css`
  list-style: none; // Removes the bullet points
  padding: 0;
  margin: 0;
`
const listItemCss = css`
  margin-inline-start: 0;
  padding-inline-start: 0;
`

// This helps the dividers line up better with the hover zones
// of the expander headers
const slightBleedDividerCss = css`
  margin: 0 calc(var(--spacer-xxs) * -1);
`

// Keep `external` prop for backward compatibility (was previously used by consumers to prepend baseUrl via buildUrl)
export default function CollapsedNavLinks({ nonReligiousMode, hideAppBtns = false, external = false }) {
  const { navigation } = useDynamicLinkContext()
  const [openExpanderIndex, setOpenExpanderIndex] = useState()
  const [isAuthorized] = useCanAddPersonalData()

  function handleExpanderOpen(index) {
    if (openExpanderIndex === index) {
      setOpenExpanderIndex(null)
    } else {
      setOpenExpanderIndex(index)
    }
  }

  return (
    <>
      {navigation?.footer?.map(
        (section, index) =>
          !section.hidden && (
            <Fragment key={section.id || section.title}>
              <div className={slightBleedDividerCss}>
                <Divider />
              </div>
              <Expander
                collapsedHeight="5"
                open={openExpanderIndex === index}
                setOpen={() => handleExpanderOpen(index)}
              >
                <ExpanderHeader marginY="xs" gutters="xxs">
                  <Paragraph dense size="sm" as="strong">
                    {section.text || section.title}
                  </Paragraph>
                </ExpanderHeader>
                <ExpanderContent>
                  <ul className={listCss} aria-label={section.title}>
                    {(section.sub || section.subNav).map(
                      ({ id, text, url, isNew, hidden, dataTestId, ...linkProps }) =>
                        !hidden && (
                          <li key={id} className={listItemCss}>
                            <Link
                              to={buildUrl(url, external)}
                              className={linkCss}
                              data-test-id={dataTestId}
                              external
                              noLinkStyles
                              wayfinding
                              {...linkProps}
                            >
                              {text} {isNew && <span className={newCss}>NEW</span>}
                            </Link>
                          </li>
                        )
                    )}
                  </ul>
                  <Separator size="sm" />
                </ExpanderContent>
              </Expander>
            </Fragment>
          )
      )}
      {!nonReligiousMode && isAuthorized && !hideAppBtns && (
        <>
          <Separator />
          <AppBtns />
        </>
      )}
    </>
  )
}
